
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4mihy", function(module, exports) {

var $cJCba = parcelRequire("cJCba");

const $4aa61b5693986156$export$2799e7163d440679 = (createAnalyticsEvent, source, importSource, importDate, contentId, rating, dataFormat, feedback)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'submitted',
            actionSubject: 'survey',
            actionSubjectId: 'importFeedbackSurvey',
            source: source,
            attributes: {
                rating: rating,
                dataFormat: dataFormat,
                feedback: feedback,
                importType: importSource,
                importDate: importDate.toISOString(),
                contentType: (0, $cJCba.getIsWhiteboardSource)(importSource) ? 'whiteboard' : 'page',
                contentId: contentId
            }
        }
    }).fire();
};
module.exports["submitSurveyFeedback"] = $4aa61b5693986156$export$2799e7163d440679;

});

parcelRegister("cJCba", function(module, exports) {
var $ac1d1a087c23a95b$export$ddc693d0d8207b4d = /*#__PURE__*/ function(ImportSource) {
    ImportSource["NOTION"] = "Notion";
    ImportSource["MIRO"] = "Miro";
    ImportSource["MURAL"] = "Mural";
    return ImportSource;
}({});
const $ac1d1a087c23a95b$export$5571cbf5d27f8c0c = (importSource)=>{
    return [
        "Miro",
        "Mural"
    ].map((source)=>source.toLowerCase()).includes(importSource.toLowerCase());
};
const $ac1d1a087c23a95b$export$38afe04e637d5e32 = (importSource)=>{
    const normalizedInput = importSource.toLowerCase();
    for (const source of Object.values($ac1d1a087c23a95b$export$ddc693d0d8207b4d)){
        if (normalizedInput.includes(source.toLowerCase())) return source;
    }
    return undefined;
};
module.exports["ImportSource"] = $ac1d1a087c23a95b$export$ddc693d0d8207b4d;
module.exports["getIsWhiteboardSource"] = $ac1d1a087c23a95b$export$5571cbf5d27f8c0c;
module.exports["getImportSourceEnum"] = $ac1d1a087c23a95b$export$38afe04e637d5e32;

});

parcelRegister("jQob7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $2gD2K = parcelRequire("2gD2K");


var $9EtP6 = parcelRequire("9EtP6");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $dpPtd = parcelRequire("dpPtd");


var $3sFtD = parcelRequire("3sFtD");


var $9wGTI = parcelRequire("9wGTI");


var $4mihy = parcelRequire("4mihy");





var $cJCba = parcelRequire("cJCba");


var $cgtv4 = parcelRequire("cgtv4");

const $b8d9cf0582cd5f3a$export$5487dbca878f120b = (0, $cgtv4.defineMessages)({
    mentions: {
        id: "import-feedback.data-format-options.notion.mentions",
        defaultMessage: "@mentions"
    },
    audioEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.audio-embedded-link",
        defaultMessage: "Audio (embedded link)"
    },
    attachments: {
        id: "import-feedback.data-format-options.notion.attachments",
        defaultMessage: "Attachments"
    },
    blockEquation: {
        id: "import-feedback.data-format-options.notion.block-equation",
        defaultMessage: "Block equation"
    },
    breadcrumb: {
        id: "import-feedback.data-format-options.notion.breadcrumb",
        defaultMessage: "Breadcrumb"
    },
    bulletedLists: {
        id: "import-feedback.data-format-options.notion.bulleted-lists",
        defaultMessage: "Bullet lists"
    },
    button: {
        id: "import-feedback.data-format-options.notion.button",
        defaultMessage: "Button"
    },
    callout: {
        id: "import-feedback.data-format-options.notion.callout",
        defaultMessage: "Callout"
    },
    codeBlock: {
        id: "import-feedback.data-format-options.notion.code-block",
        defaultMessage: "Code block"
    },
    codeMermaid: {
        id: "import-feedback.data-format-options.notion.code-mermaid",
        defaultMessage: "Code - Mermaid (diagram)"
    },
    twoColumns: {
        id: "import-feedback.data-format-options.notion.two-columns",
        defaultMessage: "2 columns"
    },
    customizedText: {
        id: "import-feedback.data-format-options.notion.customized-text",
        defaultMessage: "Customized text"
    },
    databaseChildPageProperties: {
        id: "import-feedback.data-format-options.notion.database-child-page-properties",
        defaultMessage: "Database child page properties"
    },
    dates: {
        id: "import-feedback.data-format-options.notion.dates",
        defaultMessage: "Dates"
    },
    dividers: {
        id: "import-feedback.data-format-options.notion.dividers",
        defaultMessage: "Dividers"
    },
    embed: {
        id: "import-feedback.data-format-options.notion.embed",
        defaultMessage: "Embed (e.g. Figma)"
    },
    emojis: {
        id: "import-feedback.data-format-options.notion.emojis",
        defaultMessage: "Emojis"
    },
    headerImages: {
        id: "import-feedback.data-format-options.notion.header-images",
        defaultMessage: "Header images"
    },
    headings: {
        id: "import-feedback.data-format-options.notion.headings",
        defaultMessage: "Headings"
    },
    images: {
        id: "import-feedback.data-format-options.notion.images",
        defaultMessage: "Images"
    },
    inlineEquation: {
        id: "import-feedback.data-format-options.notion.inline-equation",
        defaultMessage: "Inline equation"
    },
    linkToPage: {
        id: "import-feedback.data-format-options.notion.link-to-page",
        defaultMessage: "Link to page"
    },
    numberedLists: {
        id: "import-feedback.data-format-options.notion.numbered-lists",
        defaultMessage: "Numbered lists"
    },
    pageComments: {
        id: "import-feedback.data-format-options.notion.page-comments",
        defaultMessage: "Page comments"
    },
    pageEmojis: {
        id: "import-feedback.data-format-options.notion.page-emojis",
        defaultMessage: "Page emojis"
    },
    quotes: {
        id: "import-feedback.data-format-options.notion.quotes",
        defaultMessage: "Quotes"
    },
    reminder: {
        id: "import-feedback.data-format-options.notion.reminder",
        defaultMessage: "Reminder"
    },
    staticTables: {
        id: "import-feedback.data-format-options.notion.static-tables",
        defaultMessage: "Static tables"
    },
    syncedBlock: {
        id: "import-feedback.data-format-options.notion.synced-block",
        defaultMessage: "Synced block"
    },
    tableCustomization: {
        id: "import-feedback.data-format-options.notion.table-customization",
        defaultMessage: "Table customization"
    },
    tableData: {
        id: "import-feedback.data-format-options.notion.table-data",
        defaultMessage: "Table data"
    },
    tableOfContents: {
        id: "import-feedback.data-format-options.notion.table-of-contents",
        defaultMessage: "Table of contents"
    },
    todoList: {
        id: "import-feedback.data-format-options.notion.todo-list",
        defaultMessage: "To-Do list"
    },
    toggleHeading: {
        id: "import-feedback.data-format-options.notion.toggle-heading",
        defaultMessage: "Toggle heading"
    },
    toggleList: {
        id: "import-feedback.data-format-options.notion.toggle-list",
        defaultMessage: "Toggle list"
    },
    videoEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.video-embedded-link",
        defaultMessage: "Video (embedded link)"
    },
    webBookmark: {
        id: "import-feedback.data-format-options.notion.web-bookmark",
        defaultMessage: "Web bookmark"
    },
    other: {
        id: "import-feedback.data-format-options.notion.other",
        defaultMessage: "Other"
    }
});





const $78b530d7902d0707$export$c02ae8a2bd2ff74a = (0, $cgtv4.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.miro.comments",
        defaultMessage: "Comments"
    },
    colors: {
        id: "import-feedback.data-format-options.miro.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.miro.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.miro.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.miro.shapes",
        defaultMessage: "Shapes"
    },
    talkTracks: {
        id: "import-feedback.data-format-options.miro.talk-tracks",
        defaultMessage: "Talk Tracks"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.miro.locked-elements",
        defaultMessage: "Locked Elements"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.miro.sticky-notes",
        defaultMessage: "Sticky notes"
    },
    frames: {
        id: "import-feedback.data-format-options.miro.frames",
        defaultMessage: "Frames"
    },
    borders: {
        id: "import-feedback.data-format-options.miro.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.miro.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.miro.website-embeds",
        defaultMessage: "Website embeds"
    },
    jiraCards: {
        id: "import-feedback.data-format-options.miro.jira-cards",
        defaultMessage: "Jira cards"
    },
    tables: {
        id: "import-feedback.data-format-options.miro.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.miro.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.miro.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.miro.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.miro.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.miro.mind-maps",
        defaultMessage: "Mind maps"
    },
    other: {
        id: "import-feedback.data-format-options.miro.other",
        defaultMessage: "Other"
    }
});





const $ff44c6ff801bbed9$export$47d9fbb91e8e28a3 = (0, $cgtv4.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.mural.comments",
        defaultMessage: "Comments"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.mural.sticky-notes",
        defaultMessage: "Sticky Notes"
    },
    borders: {
        id: "import-feedback.data-format-options.mural.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.mural.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.mural.website-embeds",
        defaultMessage: "Website Embeds"
    },
    tables: {
        id: "import-feedback.data-format-options.mural.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.mural.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.mural.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.mural.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.mural.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.mural.mind-maps",
        defaultMessage: "Mind Maps"
    },
    colors: {
        id: "import-feedback.data-format-options.mural.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.mural.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.mural.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.mural.shapes",
        defaultMessage: "Shapes"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.mural.locked-elements",
        defaultMessage: "Locked Elements"
    },
    other: {
        id: "import-feedback.data-format-options.mural.other",
        defaultMessage: "Other"
    }
});


const $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).mentions,
        value: 'mentions'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).audioEmbeddedLink,
        value: 'audio_embedded_link'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).attachments,
        value: 'attachments'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).blockEquation,
        value: 'block_equation'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).breadcrumb,
        value: 'breadcrumb'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).bulletedLists,
        value: 'bulleted_lists'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).button,
        value: 'button'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).callout,
        value: 'callout'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).codeBlock,
        value: 'code_block'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).codeMermaid,
        value: 'code_mermaid'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).twoColumns,
        value: 'two_columns'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).customizedText,
        value: 'customized_text'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).databaseChildPageProperties,
        value: 'database_child_properties'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).dates,
        value: 'dates'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).dividers,
        value: 'dividers'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).embed,
        value: 'embed'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).emojis,
        value: 'emojis'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).headerImages,
        value: 'header_images'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).headings,
        value: 'headings'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).images,
        value: 'images'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).inlineEquation,
        value: 'inline_equation'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).linkToPage,
        value: 'link_to_page'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).numberedLists,
        value: 'numbered_lists'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).pageComments,
        value: 'page_comments'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).pageEmojis,
        value: 'page_emojis'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).quotes,
        value: 'quotes'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).reminder,
        value: 'reminder'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).staticTables,
        value: 'static_tables'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).syncedBlock,
        value: 'synced_block'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).tableCustomization,
        value: 'table_customization'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).tableData,
        value: 'table_data'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).tableOfContents,
        value: 'table_of_contents'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).todoList,
        value: 'todo_list'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).toggleHeading,
        value: 'toggle_heading'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).toggleList,
        value: 'toggle_list'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).videoEmbeddedLink,
        value: 'video_embedded_link'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).webBookmark,
        value: 'web_bookmark'
    },
    {
        message: (0, $b8d9cf0582cd5f3a$export$5487dbca878f120b).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).comments,
        value: 'comments'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).colors,
        value: 'colors'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).connectors,
        value: 'connectors'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).rotations,
        value: 'rotations'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).shapes,
        value: 'shapes'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).talkTracks,
        value: 'talk_tracks'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).frames,
        value: 'frames'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).borders,
        value: 'borders'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).draw,
        value: 'draw'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).jiraCards,
        value: 'jira_cards'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).tables,
        value: 'tables'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).gifs,
        value: 'gifs'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).text,
        value: 'text'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).stamps,
        value: 'stamps'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).tags,
        value: 'tags'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $78b530d7902d0707$export$c02ae8a2bd2ff74a).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).borders,
        value: 'borders'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).colors,
        value: 'colors'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).comments,
        value: 'comments'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).connectors,
        value: 'connectors'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).draw,
        value: 'draw'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).gifs,
        value: 'gifs'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).rotations,
        value: 'rotations'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).shapes,
        value: 'shapes'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).stamps,
        value: 'stamps'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).tables,
        value: 'tables'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).tags,
        value: 'tags'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).text,
        value: 'text'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $ff44c6ff801bbed9$export$47d9fbb91e8e28a3).other,
        value: 'other'
    }
];
const $b21152ef0867f201$export$1e5c15dd4d474cfc = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
const $b21152ef0867f201$export$769861949a982d7a = (importSource)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let dataFormatOptions;
    switch(importSource){
        case (0, $cJCba.ImportSource).NOTION:
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MIRO:
            dataFormatOptions = $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MURAL:
            dataFormatOptions = $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS;
            break;
        default:
            // Should never happen
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
    }
    return dataFormatOptions.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};








const $a14bce3fd3c2a8ba$export$4055a71a6988efc8 = (0, $cgtv4.defineMessages)({
    modalTitle: {
        id: "import-feedback.feedback-modal.title",
        defaultMessage: "Give feedback on imported content"
    },
    dataFormatHelperText: {
        id: "import-feedback.feedback-modal.data-format-helper-text",
        defaultMessage: "Start typing to get a list of possible matches or press down to select."
    },
    requiredFieldsAsterisk: {
        id: "import-feedback.feedback-modal.required-fields-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    feedbackText: {
        id: "import-feedback.feedback-modal.feedback-text",
        defaultMessage: "This content was imported from {source }. Please let us know what issues you found below!"
    },
    dataFormatLabel: {
        id: "import-feedback.feedback-modal.data-format-label",
        defaultMessage: "Data formats with issues"
    },
    dataFormatClearControlLabel: {
        id: "import-feedback.feedback-modal.data-format-clear-control-label",
        defaultMessage: "Clear selected data format"
    },
    tellUsAboutYourExperience: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience",
        defaultMessage: "Tell us about your experience"
    },
    tellUsAboutYourExperiencePlaceholder: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience-placeholder",
        defaultMessage: "Please expand on what could be improved for this imported content."
    },
    feedbackButton: {
        id: "import-feedback.feedback-modal.feedback-button",
        defaultMessage: "Send Feedback"
    },
    closeButton: {
        id: "import-feedback.feedback-modal.close-button",
        defaultMessage: "Cancel"
    },
    selectDataFormatError: {
        id: "import-feedback.feedback-modal.select-data-format-error",
        defaultMessage: "Please select a data format"
    },
    submittedTitle: {
        id: "import-feedback.feedback-modal.submitted-title",
        defaultMessage: "Thanks!"
    },
    submittedDescription: {
        id: "import-feedback.feedback-modal.submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    }
});


const $3069ee56b74f24de$export$5efdacda4e928df9 = ({ isOpen: isOpen, closeModal: closeModal, importSource: importSource, importDate: importDate, contentId: contentId, onFeedbackSubmit: onFeedbackSubmit })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const importSourceEnum = (0, $cJCba.getImportSourceEnum)(importSource);
    const NOTION_DATA_FORMAT_OPTIONS = (0, $b21152ef0867f201$export$1e5c15dd4d474cfc)();
    const DATA_FORMAT_OPTIONS = (0, $b21152ef0867f201$export$769861949a982d7a)(importSourceEnum);
    if (!importSourceEnum && (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback')) return null;
    const onSubmit = (data)=>{
        if (!data['data-format'] || data['data-format'].length === 0) return {
            'data-format': intl.formatMessage((0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).selectDataFormatError)
        };
        (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackSurveyModal', importSourceEnum ?? importSource, importDate, contentId, 'negative', // Modal only shown for negative feedback
        data['data-format'].map((option)=>option.value), data['tell-us-about-your-experience']);
        closeModal();
        onFeedbackSubmit();
        showFlag({
            isAutoDismiss: true,
            title: intl.formatMessage((0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).submittedTitle),
            description: intl.formatMessage((0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).submittedDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #22A06B)",
                label: ""
            })
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: closeModal,
        width: "large",
        testId: "import-feedback-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ...formProps,
            id: "feedback-modal-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).requiredFieldsAsterisk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jVhgp.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...(0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).feedbackText,
            values: {
                source: importSourceEnum
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "data-format",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).dataFormatLabel),
            isRequired: true,
            "aria-required": true,
            testId: "data-format-select-field"
        }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
                inputId: id,
                ...rest,
                options: (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback') ? DATA_FORMAT_OPTIONS : NOTION_DATA_FORMAT_OPTIONS,
                menuPosition: "fixed",
                isClearable: true,
                isMulti: true,
                clearControlLabel: intl.formatMessage((0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).dataFormatClearControlLabel),
                testId: "data-format-select-dropdown"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).dataFormatHelperText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).tellUsAboutYourExperience),
            name: "tell-us-about-your-experience",
            testId: "tell-us-about-your-experience-field",
            isRequired: true,
            "aria-required": true
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
                ...fieldProps,
                placeholder: intl.formatMessage((0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).tellUsAboutYourExperiencePlaceholder),
                testId: "tell-us-about-your-experience-textarea"
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: closeModal,
            testId: "feedback-modal-close-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).closeButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            type: "submit",
            testId: "feedback-modal-submit-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $a14bce3fd3c2a8ba$export$4055a71a6988efc8).feedbackButton))))))));
};
module.exports["FeedbackModal"] = $3069ee56b74f24de$export$5efdacda4e928df9;

});


//# sourceMappingURL=ExternalSharePage.7aeafa51.js.map
